import formatIsoDate from '@/services/general/formatIsoDate';
import calculArrondi from '@/services/calcul/calculArrondi';

export default function preparationEnvoieBackEcheancier(echeancier) {
  echeancier.forEach((echeance) => {
    delete echeance.key;
    echeance.debutPeriode = formatIsoDate(echeance.debutPeriode);
    echeance.finPeriode = formatIsoDate(echeance.finPeriode);
    echeance.dateEcheance = formatIsoDate(echeance.dateEcheance);
    echeance.montantHt = calculArrondi(echeance.montantHt);
  });
}
